import { useEffect, useRef, useState } from "react";
import {
  MagnifyingGlassIcon,
  PawPrintIcon,
  PlusIcon,
  UserIcon,
  UsersThreeIcon,
  XIcon,
} from "@phosphor-icons/react";

const acciones = [
  { vista: "mascota-encontrada", titulo: "Encontré una mascota", detalle: "Ayúdala a volver con su familia", Icon: PawPrintIcon, tono: "green" },
  { vista: "mascota-perdida", titulo: "Busco una mascota", detalle: "Publica un reporte de búsqueda", Icon: MagnifyingGlassIcon, tono: "green" },
  { vista: "persona-encontrada", titulo: "Encontré a una persona", detalle: "Reporta que se encuentra a salvo", Icon: UserIcon, tono: "blue" },
  { vista: "persona-desaparecida", titulo: "Busco una persona", detalle: "Inicia una búsqueda comunitaria", Icon: UsersThreeIcon, tono: "blue" },
];

export default function MenuReportar({ onNavigate, className = "" }) {
  const [abierto, setAbierto] = useState(false);
  const contenedorRef = useRef(null);

  useEffect(() => {
    if (!abierto) return undefined;
    function cerrar(evento) {
      if (evento.key === "Escape" || !contenedorRef.current?.contains(evento.target)) setAbierto(false);
    }
    document.addEventListener("keydown", cerrar);
    document.addEventListener("pointerdown", cerrar);
    return () => {
      document.removeEventListener("keydown", cerrar);
      document.removeEventListener("pointerdown", cerrar);
    };
  }, [abierto]);

  function elegir(vista) {
    setAbierto(false);
    onNavigate(vista);
  }

  return (
    <div className={`quick-menu ${className}`} ref={contenedorRef}>
      <button type="button" className="quick-menu__trigger" aria-label={abierto ? "Cerrar opciones de reporte" : "Crear un reporte"} aria-haspopup="menu" aria-expanded={abierto} onClick={() => setAbierto((actual) => !actual)}>
        {abierto ? <XIcon weight="bold" /> : <PlusIcon weight="bold" />}
      </button>
      {abierto && <div className="quick-menu__panel" role="menu" aria-label="¿Qué quieres reportar?">
        <div className="quick-menu__heading"><strong>¿Cómo podemos ayudarte?</strong><span>Elige el tipo de reporte</span></div>
        {acciones.map(({ vista, titulo, detalle, Icon, tono }) => <button type="button" role="menuitem" className={`quick-menu__item quick-menu__item--${tono}`} onClick={() => elegir(vista)} key={vista}><span><Icon weight="duotone" /></span><span><strong>{titulo}</strong><small>{detalle}</small></span></button>)}
      </div>}
    </div>
  );
}
